import { InputText, type InputTextProps } from 'primereact/inputtext'

/**
 * Paylaşılan metin girişi (013 tasarım dili). PrimeReact InputText üzerine kurulu; Figma görünümü
 * (~40px yükseklik, 14px, kırmızı odak — mavi hover/odak yok) global override'lardan gelir. Tam
 * genişlik. Tüm formlar bunu kullanır (Reuse Mandate) → tek tip giriş.
 */
export default function TextInput({ className, ...props }: Readonly<InputTextProps>) {
  return <InputText {...props} className={['ui-input', className].filter(Boolean).join(' ')} />
}
